import DomHelper from './helpers/language-selector-dom-helper';

Hop.defineModule('language-selector', (domRoot) => {
    function init() {
        registerEventListeners();
    }

    function registerEventListeners() {
        registerLanguageSelectorEventListener();
    }

    function registerLanguageSelectorEventListener() {
        const smallLanguageSelectorNodes = DomHelper.getSmallLanguageSelectorNodeList(domRoot);
        if (smallLanguageSelectorNodes) {
            smallLanguageSelectorNodes.forEach((smallLanguageSelectorNode) => {
                smallLanguageSelectorNode.addEventListener('click', handleLanguageSelectorClick);
            });
        }

        const largeLanguageSelectorNodes = DomHelper.getLargeLanguageSelectorNodeList(domRoot);
        if (largeLanguageSelectorNodes) {
            largeLanguageSelectorNodes.forEach((largeLanguageSelectorNode) => {
                largeLanguageSelectorNode.addEventListener('click', handleLanguageSelectorClick);
            });
        }
    }

    function handleLanguageSelectorClick() {
        $('#languageSelectorModal').modal('show');
    }

    init();

    return function destroy() {
        const smallLanguageSelectorNodes = DomHelper.getSmallLanguageSelectorNodeList(domRoot);
        if (smallLanguageSelectorNodes) {
            smallLanguageSelectorNodes.forEach((smallLanguageSelectorNode) => {
                smallLanguageSelectorNode.removeEventListener('click', handleLanguageSelectorClick);
            });
        }

        const largeLanguageSelectorNodes = DomHelper.getLargeLanguageSelectorNodeList(domRoot);
        if (largeLanguageSelectorNodes) {
            largeLanguageSelectorNodes.forEach((largeLanguageSelectorNode) => {
                largeLanguageSelectorNode.removeEventListener('click', handleLanguageSelectorClick);
            });
        }
    };
});
